import { Currency } from "@redotech/money/currencies";
import * as z from "zod/v4";
import { SlideInPanelAnchorLocation } from "../slide-in-panel/slide-in-panel-anchor-location";
import { InsertionPosition } from "../widget";

type CommonLoyaltyInfo = { pointsForPurchase: number };

export type LoggedOutLoyaltyInfo = CommonLoyaltyInfo & { loggedIn: false };

export type LoggedInLoyaltyInfo = CommonLoyaltyInfo & {
  loggedIn: true;
  customerId: string;
  customerName: string | undefined;
  pointsBalance: number;
  singlePointValue: { currency: Currency; amount: number };
  loyaltyDashboardUrl?: string | undefined;
};

export type LoyaltyInfo = LoggedOutLoyaltyInfo | LoggedInLoyaltyInfo;

/**
 * Main schema for loyalty storefront popup settings
 */
const storefrontPopupSchema_ = z.object({
  enabled: z.boolean(),
  anchorPosition: z.enum(SlideInPanelAnchorLocation),
});

export const storefrontPopupSchema: z.ZodType<StorefrontPopup> =
  storefrontPopupSchema_;

export type StorefrontPopup = z.infer<typeof storefrontPopupSchema_>;

const storefrontEmbeddingSchema_ = z.object({
  enabled: z.boolean(),
  selector: z.string(),
  insertPosition: z.enum(InsertionPosition),
});

export const storefrontEmbeddingSchema: z.ZodType<StorefrontEmbedding> =
  storefrontEmbeddingSchema_;

export type StorefrontEmbedding = z.infer<typeof storefrontEmbeddingSchema_>;
